import * as React from "react";
import { connect } from 'react-redux';
import { hideIveriScreen, showIveriScreen, showLoadingScreen } from "../../actions/fullscreenActions";
import { hideModal } from "../../actions/modalActions";
import { navigateTo } from "../../actions/navigationActions";
import { getUserBankingDetails } from "../../actions/profileActions";
import { IveriSubmission, updateCreditCard } from "../../actions/salesActions";
import { LEGAL_STUFF, PERSONAL_INFO } from "../../routes/routes";

class IveriSuccess extends React.Component<any, any> {

    constructor(props: any) {
        super(props);
        this.componentDidMount = this.componentDidMount.bind(this);
    }

    async componentDidMount() {
        if (this.props.profile.policyId !== '') {
            await this.props.dispatchHideModal();
            await this.props.dispatchShowLoadingScreen();
            await this.props.dispatchGetUserBankingDetails()
            await this.props.dispatchHideLoadingScreen();
        } 
        else {
            this.props.dispatchShowLoadingScreen();
            this.props.dispatchHideModal();
            this.props.dispatchRedirectToLegal();
            this.props.dispatchHideLoadingScreen();
        }
        
    }

    render() {
        return (
            <>
            </>
            )
    }
}


const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchShowLoadingScreen: () => dispatch(showIveriScreen()),
        dispatchHideLoadingScreen: () => dispatch(hideIveriScreen()),
        dispatchHideModal: () => dispatch(hideModal()),
        dispatchRedirectToLegal: () => dispatch(navigateTo(LEGAL_STUFF)),
        dispatchGetUserBankingDetails: () => dispatch(getUserBankingDetails()),
        dispatchUpdatePolicy: () => dispatch(updateCreditCard()),
        dispatchIveriSubmission: (quote) => dispatch(IveriSubmission(quote)),
        dispatchRedirectToPersonalDetails: () => dispatch(navigateTo(PERSONAL_INFO)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IveriSuccess)